<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="editAssetDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <DialogTitle
                    :close="closeEditItem"
                    :dialog-name="dialogName"
                />
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex>
                                <v-select
                                    :error-messages="editAssetTypeIdErrors"
                                    :items="assetTypeList"
                                    item-text="name"
                                    item-value="assetTypeId"
                                    @blur="$v.editAssetTypeId.$touch()"

                                    @input="$v.editAssetTypeId.$touch()"
                                    label="Asset Type"
                                    v-model="editAssetTypeId"
                                />
                            </v-flex>
                            <v-flex>
                                <v-select
                                    :error-messages="editAssetStatusIdErrors"
                                    :items="assetStatusList"
                                    item-text="name"
                                    item-value="assetStatusId"
                                    @blur="$v.editAssetStatusId.$touch()"

                                    @input="$v.editAssetStatusId.$touch()"
                                    label="Asset Status"
                                    v-model="editAssetStatusId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Name"
                                    v-model="editDescription"
                                    :error-messages="editDescriptionErrors"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    clearable
                                    :items="livePersonnel()"
                                    item-text="name"
                                    item-value="personId"
                                    label="Personnel"
                                    v-model="editPersonId"
                                />
                            </v-flex>
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="acquisitionDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :error-messages="editAcquisitionDateErrors"
                                            @blur="$v.editAcquisitionDate.$touch()"
                                            @input="acquisitionDateMenu = false && $v.editAcquisitionDate.$touch()"
                                            label="Acquisition Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="editAcquisitionDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        :error-messages="editAcquisitionDateErrors"
                                        @blur="$v.editAcquisitionDate.$touch()"
                                        @input="acquisitionDateMenu = false && $v.editAcquisitionDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="editAcquisitionDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.editAcquisitionDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="warrantyExpiryDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            @blur="$v.editWarrantyExpiryDate.$touch()"
                                            @input="warrantyExpiryDateMenu = false && $v.editWarrantyExpiryDate.$touch()"
                                            label="Warranty Expiry Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="editWarrantyExpiryDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @blur="$v.editWarrantyExpiryDate.$touch()"
                                        @input="warrantyExpiryDateMenu = false && $v.editWarrantyExpiryDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="editWarrantyExpiryDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.editWarrantyExpiryDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Cost"
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    v-model="editCost"
                                />
                            </v-flex>
                            <v-flex>
                                <v-select
                                    :items="currencyList"
                                    item-text="name"
                                    item-value="id"
                                    @blur="$v.editCurrencyId.$touch()"
                                    @input="$v.editCurrencyId.$touch()"
                                    label="Currency"
                                    v-model="editCurrencyId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="ECS Reference Code"
                                    v-model="editEcsReferenceCode"
                                    :error-messages="editEcsReferenceCodeErrors"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Serial Number"
                                    v-model="editSerialNumber"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-textarea
                                    label="Comments"
                                    v-model="editComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <DialogActions
                    :close="closeEditItem"
                    :save="saveEditItemAndCloseDialog"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from './../../ManagePersonnel/components/editTableFunctions';
    import {required,} from 'vuelidate/lib/validators'
    import {LOAD_PERSON_ASSET_TO_EDIT, RESET_DEFAULT_PERSON_ASSET_TO_EDIT, TOGGLE_EDIT_PERSON_ASSET_DIALOG, UPDATE_EDIT_PERSON_ASSET_FIELD} from "@/store/person_asset/mutations";
    import {SAVE_EDITED_PERSON_ASSET} from "@/store/person_asset/actions.js";
    import {FETCH_PERSON_ASSET_LIST} from "../../../store/person_asset/actions";
    import DialogTitle from "../../../components/DialogTitle";
    import DialogActions from "../../../components/DialogActions";

    export default {
        name: "EditAssetDialog",

        validations: {
            editEcsReferenceCode: {required},
            editDescription: {required},
            editAssetTypeId: {required},
            editAssetStatusId: {required},
            editAcquisitionDate: {required},
            editWarrantyExpiryDate: {},
            editLastMotDate: {},
        },

        components: {
            DialogActions,
            DialogTitle
        },

        mixins: [
            EditTableFunctions,
        ],

        data() {
            return {
                // Required for editTableFunctions
                idName: 'feedbackId',
                dialogName: 'Edit Asset',
                acquisitionDateMenu: false,
                warrantyExpiryDateMenu: false,
                endDateMenu: false,
            }
        },
        computed: {
            ...mapGetters(
                [
                    "assetTypeList",
                    "livePersonnel",
                    "assetStatusList",
                    "currencyList",
                ]
            ),
            editAssetDialog: {
                get() {
                    return this.$store.state.person_asset.editPersonAssetDialog;
                },
            },
            editDescription: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.description;
                },
                set(value) {
                    this.updateValue('description', value);
                },
            },
            editDescriptionErrors() {
                const errors = [];
                if (!this.$v.editDescription.$dirty) return errors;
                !this.$v.editDescription.required && errors.push('required.');
                return errors
            },

            editAssetTypeId: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.assetTypeId;
                },
                set(value) {
                    this.updateValue('assetTypeId', value);
                },
            },

            editAssetTypeIdErrors() {
                const errors = [];
                if (!this.$v.editAssetTypeId.$dirty) return errors;
                !this.$v.editAssetTypeId.required && errors.push('required.');
                return errors
            },

            editCost: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.cost;
                },
                set(value) {
                    this.updateValue('cost', value);
                },
            },

            editCurrencyId: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.currencyId;
                },
                set(value) {
                    this.updateValue('currencyId', value);
                },
            },

            editAssetStatusId: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.assetStatusId;
                },
                set(value) {
                    this.updateValue('assetStatusId', value);
                },
            },

            editAssetStatusIdErrors() {
                const errors = [];
                if (!this.$v.editAssetStatusId.$dirty) return errors;
                !this.$v.editAssetStatusId.required && errors.push('required.');
                return errors
            },

            editAcquisitionDate: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.acquisitionDate;
                },
                set(value) {
                    this.updateValue('acquisitionDate', value);
                },
            },

            editAcquisitionDateErrors() {
                const errors = [];
                if (!this.$v.editAcquisitionDate.$dirty) return errors;
                !this.$v.editAcquisitionDate.required && errors.push('required.');
                return errors
            },

            editEcsReferenceCode: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.ecsReferenceCode;
                },
                set(value) {
                    this.updateValue('ecsReferenceCode', value);
                },
            },

            editEcsReferenceCodeErrors() {
                const errors = [];
                if (!this.$v.editEcsReferenceCode.$dirty) return errors;
                !this.$v.editEcsReferenceCode.required && errors.push('required.');
                return errors
            },

            editSerialNumber: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.serialNumber;
                },
                set(value) {
                    this.updateValue('serialNumber', value);
                },
            },

            editComments: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.comments;
                },
                set(value) {
                    this.updateValue('comments', value);
                },
            },

            editWarrantyExpiryDate: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.warrantyExpiryDate;
                },
                set(value) {
                    this.updateValue('warrantyExpiryDate', value);
                },
            },
            editPersonId: {
                get() {
                    return this.$store.state.person_asset.editPersonAsset.personId;
                },
                set(value) {
                    this.updateValue('personId', value);
                },
            }
        },

        methods: {
            async validateAll() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }

                let areValid = false;

                if (formState == 'complete') {
                    areValid = true;
                }

                return areValid;
            },

            ...mapActions({
                fetchItem: FETCH_PERSON_ASSET_LIST,
                updateTableItemRecord: SAVE_EDITED_PERSON_ASSET,
                // saveNewTableItemRecord: '',
                // deleteTableItem: '',
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_ASSET_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_ASSET_TO_EDIT,
                updateTableItemToEdit: UPDATE_EDIT_PERSON_ASSET_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_ASSET_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
